export default __webpack_public_path__ + "static/media/hahaIcon.ce9168a5.png";